import React, { useState } from 'react';
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Card,
} from 'react-bootstrap';
import authService from '../services/authService';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import './Common.scss';

const Login: React.FC = () => {
  const [loginId, setLoginId] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (
    e: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    e.preventDefault();
    try {
      const response = await authService.login(loginId, password);
      // ログイン成功後の処理
      login(response.access_token, response.id);
      navigate('/');
    } catch (err) {
      setError('ログインに失敗しました。');
    }
  };

  return (
    <div className="page-layout center-content">
      <Container fluid>
        <Row className="justify-content-center min-vh-100 g-0">
          <Col xs={12} sm={8} md={6} lg={5}>
            <Card className="shadow">
              <Card.Body className="p-5">
                <h2 className="text-center mb-4">ログイン</h2>
                <Form onSubmit={handleSubmit}>
                  <Form.Group controlId="formBasicLoginId" className="mb-3">
                    <Form.Label>ログインID</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter loginId"
                      value={loginId}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setLoginId(e.target.value)
                      }
                      required
                    />
                  </Form.Group>

                  <Form.Group controlId="formBasicPassword" className="mb-3">
                    <Form.Label>パスワード</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setPassword(e.target.value)
                      }
                      required
                    />
                  </Form.Group>

                  {error && (
                    <Alert variant="danger" className="mb-3">
                      {error}
                    </Alert>
                  )}

                  <div className="d-grid">
                    <Button variant="primary" type="submit" size="lg">
                      ログイン
                    </Button>
                  </div>
                </Form>

                {/* <div className="text-center mt-3">
                  <p className="mb-0">
                    アカウントをお持ちでない方は <a href="/signup">こちら</a>
                  </p>
                </div> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
